export const ALERT_SEVERITY = {
    success: "success",
    warning: "warning",
    error: "error",
    info: "info"
};

// Standard alert durations in milliseconds
export const ALERT_DURATION = {
    indefinite: 0,
    short: 2000,
    long: 5000
};

export function getDefaultAlert() {
    return {
        message: "",
        duration: 0,
        severity: "",
        show: false
    };
}

export function getSuccessAlert(msg) {
    return {
        message: msg,
        duration: ALERT_DURATION.short,
        severity: ALERT_SEVERITY.success,
        show: true
    };
}

export function getErrorAlert(msg) {
    return {
        message: msg,
        duration: ALERT_DURATION.long,
        severity: ALERT_SEVERITY.error,
        show: true
    };
}
